import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from '../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../ng2-bootstrap-modal/dialog.service';
import {HostingService} from "../../../../websites/website/hosting/hosting.service";

export interface IConfirmDialogData {
  header: string;
  message: string;
}
@Component({
    selector: 'db-mobile-available',
    templateUrl: './mobile-available.component.html',
    styleUrls: ['./mobile-available.component.scss'],
    standalone: false
})
export class MobileAvailableComponent extends DialogComponent<IConfirmDialogData, any> implements OnInit, IConfirmDialogData {

  @Input() header: string;
  @Input() message: string;

  constructor(
    private _dialogService: DialogService,
    private _hostingService: HostingService
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
  }

  public cancel(): void {
    this.result = false;
    this.close();
  }

}
